import { Component, HostBinding, Input, input } from '@angular/core';

@Component({
    selector: 'sidenav-router-link', // tslint:disable-line
    template: `
        <a
          [routerLink]="route()"
          class="sidenav-link"
          [ngClass]="linkClass()"
          >
          @if (icon) {
            <i
              class="sidenav-icon"
              [ngClass]="icon"
            ></i>
          }
          <div><ng-content></ng-content></div>
          @if (badge) {
            <div
              class="ms-auto ps-1"
              >
              <div
                class="badge"
                [ngClass]="badgeClass()"
                >
                {{ badge }}
              </div>
            </div>
          }
        </a>
        `,
    standalone: false
})
export class SidenavRouterLinkComponent {
    @HostBinding('class.sidenav-item') public hostClassMain = true;
    @HostBinding('class.d-block') public hostClassBlock = true;

    @Input() @HostBinding('class.disabled') public disabled = false;
    @Input() @HostBinding('class.active') public active = false;

    public readonly route = input<any[] | string>(undefined);
    @Input() public icon: string;
    public readonly linkClass = input('');
    @Input() public badge: any = null;
    public readonly badgeClass = input('');
}
